import { useQuery } from '@apollo/client';
import GET_ASSIGNABLE_ROLES from '../queries/getAssignableRoles';

export const useUserRoleOptions = (organizationId, orgUnitId, isFree, skip) => {
  const { data, loading, error } = useQuery(GET_ASSIGNABLE_ROLES, {
    variables: { organizationId, orgUnitId, isFree },
    skip
  });

  const options = data
    ? data.assignableRoles.map(entry => ({
        value: entry.Id,
        title: entry.DisplayName
      }))
    : [];

  return { userRoleOptions: options, userRoleOptionsLoading: loading, userRoleOptionsError: error };
};
